import { useState } from "react";
import newRequest from "../../../../utils/newRequest";
import { useTranslation } from "react-i18next";

const AddLanguage = ({ isVisible, setVisibility, refreshData, onSuccess, onError }) => {
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const [nl, setNl] = useState("");

  const handleCloseCreatePopup = () => {
    setVisibility(false);
  };
  const { t, i18n } = useTranslation();

  const [localError, setLocalError] = useState(null);

  const handleAddLanguage = async () => {
    setLocalError(null);
    try {
      const response = await newRequest.post("/createLanguageWord", {
        key,
        value,
        nl,
      });
      // API returns { recordsets: [], output: {}, rowsAffected: [1] } on success
      const isSuccess =
        response?.status >= 200 &&
        response?.status < 300 &&
        (response?.data?.rowsAffected?.[0] >= 1 || response?.data?.rowsAffected === undefined);
      if (isSuccess) {
        const successMsg = `${t("Language")} ${key} ${t("has been added successfully")}.`;
        if (onSuccess) onSuccess(successMsg);
        refreshData();
        handleCloseCreatePopup();
        setKey("");
        setValue("");
        setNl("");
      } else {
        const errMsg = response?.data?.message || t("Something went wrong");
        if (onError) onError(errMsg);
        else setLocalError(errMsg);
      }
    } catch (err) {
      const errMsg = err?.response?.data?.error || err?.message || "Error";
      if (onError) onError(errMsg);
      else setLocalError(errMsg);
    }
  };

  return (
    <div>
      {localError && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] px-4 py-2 bg-red-100 border border-red-400 text-red-700 rounded shadow">
          {localError}
        </div>
      )}
      {isVisible && (
        <div className="popup-overlay z-50">
          <div className="popup-container h-auto sm:w-[45%] w-full">
            <div
              className="popup-form w-full "
              style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
              <form className="w-full">
                <h2
                  className={`text-secondary font-sans font-semibold text-2xl ${
                    i18n.language === "ar" ? "text-end" : "text-start"
                  }`}
                >
                  {t("Add")} {t("Language")}
                </h2>
                <div className="flex flex-col sm:gap-3 gap-3 mt-5">
                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="key"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Key")}
                    </label>
                    <input
                      type="text"
                      id="key"
                      value={key}
                      onChange={(e) => setKey(e.target.value)}
                      placeholder={t("Enter Key")}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="value"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Value")}
                    </label>
                    <input
                      type="text"
                      id="value"
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      placeholder={t("Enter Value")}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="nl"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      NL
                    </label>
                    <input
                      type="text"
                      id="nl"
                      value={nl}
                      onChange={(e) => setNl(e.target.value)}
                      placeholder={t("Enter NL")}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>
                </div>

                <div className="w-full flex justify-center items-center gap-8 mt-5">
                  <button
                    type="button"
                    className="px-5 py-2 w-[30%] rounded-sm bg-primary text-white font-body text-sm"
                    onClick={handleCloseCreatePopup}
                  >
                    {t("Close")}
                  </button>
                  <button
                    type="button"
                    onClick={handleAddLanguage}
                    className="px-5 py-2 rounded-sm w-[70%] bg-secondary text-white font-body text-sm ml-2"
                  >
                    {t("Add")} {t("Language")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddLanguage;
